/** Paths that must not be indexed (Doob template / demo pages). */
const DEMO_PATHS = [
  '/splash',
  '/business-consulting',
  '/business-consulting-2',
  '/corporate',
  '/business',
  '/digital-agency',
  '/finance',
  '/company',
  '/marketing',
  '/travel-agency',
  '/consulting',
  '/seo-agency',
  '/personal-portfolio',
  '/event-conference',
  '/creative-portfolio',
  '/freelancer',
  '/international-consulting',
  '/startup',
  '/web-agency',
  '/blog-grid',
  '/blog-list-view',
  '/blog-grid-sidebar',
  '/blog-list-sidebar',
  '/elements',
  '/button',
  '/service',
  '/counter',
  '/progressbar',
  '/social-share',
  '/team',
  '/testimonial',
  '/timeline',
  '/accordion',
  '/tab',
  '/pricing',
  '/split',
  '/call-to-action',
  '/video-popup',
  '/gallery',
  '/brand',
  '/advance-tab',
  '/advance-pricing',
  '/aboutus',
  '/error',
  '/portfolios',
  '/portfolio-three-column',
  '/portfolio-full-width',
  '/portfolio-grid-layout',
  '/portfolio-box-layout',
  '/Testimonial-One',
  '/Timeline-two',
  '/TeamFour',
  '/Testimonials',
  '/Timelines',
  '/Teams',
];

export function isDemoPath(pathname) {
  if (!pathname) return false;
  const p = pathname.replace(/\/$/, '') || '/';
  return DEMO_PATHS.some((demo) => p === demo || p.startsWith(`${demo}/`));
}

export default DEMO_PATHS;
